interface Props {
  data: { hour: string; count: number }[];
}

export default function HourlyStats({ data }: Props) {
  const maxVal = data.length > 0 ? Math.max(...data.map((d) => d.count)) : 1;

  return (
    <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-6 h-full flex flex-col">
      <div className="mb-5">
        <h3 className="text-white font-semibold text-base">시간대별 발송 분포</h3>
        <p className="text-gray-500 text-xs mt-0.5">하루 중 발송이 집중되는 시간대</p>
      </div>
      {data.length === 0 ? (
        <div className="flex-1 flex items-center justify-center">
          <p className="text-gray-600 text-sm">발송 데이터가 없습니다</p>
        </div>
      ) : (
        <div className="flex items-end gap-1.5 h-40">
          {data.map((d) => {
            const h = maxVal > 0 ? (d.count / maxVal) * 100 : 0;
            return (
              <div key={d.hour} className="flex-1 flex flex-col items-center gap-1 group">
                <div className="relative w-full flex items-end justify-center h-28">
                  <div className="absolute -top-7 left-1/2 -translate-x-1/2 bg-[#1a1a2e] border border-white/[0.1] rounded-lg px-2 py-1 text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                    {d.count.toLocaleString()}건
                  </div>
                  <div
                    className="w-full max-w-[14px] bg-gradient-to-t from-violet-600/80 to-pink-500/60 rounded-t-sm transition-all duration-500"
                    style={{ height: `${h}%` }}
                  />
                </div>
                <span className="text-gray-500 text-[10px]">{d.hour}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}